import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { copy } from '@/utils/cohort';
import { AUDIENCE_TYPE, TOOL_CATEGORY, CONTENT_TYPE_FILTER, REGISTRY_TYPE } from '@/utils/constants';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'registry-filter-option-display',
})

export default class RegistryFilterOptionDisplay extends Vue {

    @Prop()
    private rawFilterOptionList: any;

    @Prop()
    private selectedFilter: any;

    @Prop()
    private searchTerms: any;

    private displayList: any = [];

    @Watch('selectedFilter')
    private assembleFilterData(list: any) {
        this.selecedFilterOptionsList();
    }

    private selecedFilterOptionsList() {
        const rawList = copy(this.rawFilterOptionList);
        const displayList = [];
        for (const key in rawList) {
            if (Object.prototype.hasOwnProperty.call(rawList, key)) {
                const element = rawList[key];
                if (element.selectedItems && element.selectedItems.length > 0) {
                    const rawObject = element.items.find((item: any) =>
                        item.id === element.selectedItems[0]);
                    rawObject.key = key;
                    rawObject.name = element.name;
                    displayList.push(rawObject);
                }
            }
        }
        this.displayList = displayList;
    }

    private removefilter(index: any) {
        this.$emit('removeSelectedItem', this.displayList[index].key);
    }

    private removeSearchText() {
        this.$emit('removeSearchText');
    }
}
